angular.module('tgaAdmin')
  .controller('HubPrizesController', [
    '$scope', '$rootScope', '$state', '$window', '$filter', '$timeout', 'hubService',
    '$uibModal', 'userService', 'supportService', '$log',
    function (
      $scope, $rootScope, $state, $window, $filter, $timeout, hubService,
      $uibModal, userService, supportService, $log,
    ) {
      $scope.data = {
        hub_id: $state.params.hub_id || null,
        alerts: [],
        isAdmin: userService.checkUserType(['admin', 'super_admin', 'sales_admin', 'support_admin']),
        isEditor: userService.checkUserType(['editor', 'creator_admin']),
        isSuperAdmin: userService.checkUserType(['super_admin']),
        defaultIcon: {
          key: 'bulk-present-2',
          src: './v1/assets/images/prizes/bulk-present-2.png',
        },
        icons: [
          {
            key: 'bulk-present-1',
            src: './v1/assets/images/prizes/bulk-present-1.png',
          }, {
            key: 'bulk-present-2',
            src: './v1/assets/images/prizes/bulk-present-2.png',
          }, {
            key: 'bulk-present-3',
            src: './v1/assets/images/prizes/bulk-present-3.png',
          }, {
            key: 'gift-basket-3',
            src: './v1/assets/images/prizes/gift-basket-3.png',
          }, {
            key: 'present-1',
            src: './v1/assets/images/prizes/present-1.png',
          }, {
            key: 'present-3',
            src: './v1/assets/images/prizes/present-3.png',
          }, {
            key: 'gift-card-3',
            src: './v1/assets/images/prizes/gift-card-3.png',
          },
        ],
      };

      $scope.viewmodel = {
        prizes_enabled: false, // from db
        prizes_name: '',
        prizes: [],
        newPrize: {
          hub_prize_id: null,
          icon: $scope.data.defaultIcon.key,
          title: '',
          level: 1,
          limit: null,
        },
      };

      $scope.initialize = function () {
        $scope.loading = true;

        hubService.getHub($scope.data.hub_id).then((hub) => {
          $scope.title = `<span class="text-muted">Arcades / ${hub.name} /</span> Prizes`;
          $scope.viewmodel.prizes_enabled = hub.prizes_enabled;
          $scope.viewmodel.prizes_name = hub.prizes_title;

          if ($scope.viewmodel.prizes_enabled) {
            $scope.actions.checkAgreements();
          }
        });

        hubService.getPrizes($scope.data.hub_id).then((prizes) => {
          $scope.viewmodel.prizes = [];

          for (let i = 0; i < prizes.length; i++) {
            $scope.viewmodel.prizes.push({
              hub_prize_id: prizes[i].hub_prize_id,
              title: prizes[i].title,
              icon: prizes[i].icon || $scope.data.defaultIcon.key,
              iconIndex: $scope.data.icons.indexOf($scope.data.icons.filter((ico) => {
                const ik = prizes[i].icon || $scope.data.defaultIcon.key;
                return ico.key === ik;
              })[0]),
              level: prizes[i].level === 0 ? '' : prizes[i].level, // if 0, render placeholder
              claimed: prizes[i].claimed,
              limit: prizes[i].limit === 0 ? '' : prizes[i].limit, // if 0, render placeholder
            });
          }

          $scope.loading = false;
        });
      };

      $scope.actions = {
        checkAgreements() {
          const agreementTypePrizes = 4; // AGREEMENT_TYPE_PRIZES

          // Get the latest agreement_id for each of these types.
          supportService.getUserAgreements([agreementTypePrizes], userService.getUserData().id, $scope.data.hub_id).then((res) => {
            $scope.data.agreements = res;
            let agreedToAll = true;

            for (let i = 0; i < res.length; i++) {
              if (!res[i].date_agreed) {
                agreedToAll = false;
              }
            }

            if (!agreedToAll) {
              $uibModal.open({
                animation: true,
                templateUrl: 'templates/partials/modal-hub-prize-agreement.html',
                controller: 'HubPrizeAgreementModalController',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                  extras() {
                    return {
                      text: $scope.data.agreements[0].text,
                    };
                  },
                },
              }).result.then(() => {
                supportService.storeUserAgreements(
                  $scope.data.agreements[0].agreement_id,
                  userService.getUserData().id,
                  $scope.data.hub_id,
                );
              }).catch(() => {
                $scope.viewmodel.prizes_enabled = false;
              });
            }
          }).catch((error) => {
            $log.log(error);
          });
        },
        togglePrizes() {
          if ($scope.viewmodel.prizes_enabled) {
            $scope.actions.checkAgreements();
          }
        },
        addPrize() {
          if ($scope.viewmodel.prizes_enabled) {
            $scope.viewmodel.prizes.push({ ...$scope.viewmodel.newPrize });
          }
        },
        deletePrize(prize) {
          if (!prize.hub_prize_id) {
            const index = $scope.viewmodel.prizes.indexOf(prize);
            $scope.viewmodel.prizes.splice(index, 1);
          } else {
            prize.deleted = true;
          }
        },
        savePrizes(form) {
          form.submitted = true;

          if (form.$invalid) {
            return;
          }

          $scope.loading = true;

          hubService.updatePrizes(
            $scope.data.hub_id, $scope.viewmodel.prizes_name,
            $scope.viewmodel.prizes_enabled,
            $scope.viewmodel.prizes,
          ).then(() => {
            $scope.initialize();
            $scope.actions.createAlert('<span class="fa fa-check"></span> Prizes updated successfully.', 'success');
          }).catch(() => {
            $scope.loading = false;
          }).finally(() => {
            form.submitted = false;
          });
        },
        changeIcon(swiper) {
          const prizeIndex = swiper.container[0].getAttribute('data-prize-index');
          const prize = $scope.viewmodel.prizes.filter((p) => !p.deleted)[prizeIndex];

          if (prize) {
            prize.icon = $scope.data.icons[swiper.activeIndex].key;
            prize.iconIndex = swiper.activeIndex;
          }
        },
        changeLimit(prize) {
          if (!prize.limit) {
            prize.limit = null;
          }
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
      };

      $scope.initialize();
    },
  ]);
